module.exports = __webpack_public_path__ + "static/media/undraw_On_the_way_re_swjt.8a97b05f.svg";